import React from 'react';
import clsx from 'clsx';
import styles from './Label.module.css';

export interface LabelProps extends React.ComponentProps<'label'> {
    error?: string | null;
    required?: boolean;
    className?: string;
}

export const Label: React.FC<LabelProps> = props => {
    return (
        <label
            className={clsx(
                styles.root,
                {
                    [styles.hasError]: props.error
                },
                props.className
            )}
        >
            {props.error ? props.error : props.children}
            {props.required && !props.error && <span className={styles.required}>*</span>}
        </label>
    );
};
